import React, { useState, Fragment } from "react";
import { useStylesApp } from "hooks/useStyles";

//mostrar empresa
import {
  Grid,
  Card,
  Divider,
  CardHeader,
  Typography,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";

//material-ui.com
import { makeStyles } from "@material-ui/core/styles";

//componentes del sistema

//componentes para el boton buscar
import Button from "@material-ui/core/Button";
import CancelIcon from "@mui/icons-material/Cancel";

import { useStylesGlobal } from "configurations/styles/theme";

import { validationAnnulation } from "./validations";

import checkInputs from "utils/checkInputs";

//Color para la advertencia
import {
  palette,
  styleInput,
  msmSwalError,
  msmSwalExito,
} from "configurations/styles/theme";
import AssessmentIcon from "@material-ui/icons/Assessment";
import PageviewIcon from "@material-ui/icons/Pageview";
import { httpRepo, httpCore } from "configurations/axios";
import { API_GET_VOUCHER_BY_CUFE_2 } from "views/facturacion/AuthorizedIssuedVouchers/apis";
import { useSnackbar } from "notistack";
const useStyles = makeStyles((theme) => ({
  cardContent: {
    width: "94%",
    height: "400px",
    margin: "3%",
  },
  gridLable: {
    // paddingRight: '1%'
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  divBotonBuscar: {
    marginTop: "0.5%",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuSeleccion: {
    zIndex: "3000  ! Important",
    width: "60% !Important",
  },
  infoBusqueda: {
    marginTop: "30px",
    marginBottom: "30px",
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  fragment: {
    padding: "10px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const EventAnnulation = () => {
  const classes = useStyles();
  const classesGlobales = useStylesGlobal();
  const classesApp = useStylesApp();
  const [eventAnnulation, setEventAnnulation] = useState({});
  const [openLoader, setOpenLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [voucher, setVoucher] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [tipoComprobanteElectronico, setTipoComprobanteElectronico] = useState(
    {}
  );
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (event) => {
    setEventAnnulation({
      ...eventAnnulation,
      [event.target.name]: event.target.value,
    });
  };
  const validateEventAnnulation = (data) => {
    let newErros = validationAnnulation.onSubmit({
      cufe: data.cufe,
      motivo: data.motivo,
    });
    if (Object.entries(newErros).length > 0) {
      setErrors(newErros);
      return false;
    } else {
      return true;
    }
  };

  const validateCufe = () => {
    let error = {};
    if (checkInputs.countLenth(eventAnnulation.cufe) !== 66) {
      error.cufe = "Ingrese 66 caracteres referentes al CUFE referenciado.";
    }
    return error;
  };

  const annulation = async () => {
    if (validateEventAnnulation(eventAnnulation)) {
      setOpenLoader(true);
      await httpCore
        .post(`/eventos/anular/comprobante`, eventAnnulation)
        .then((response) => {
          if (
            response?.data?.mensajeSistema === "Evento registrado con éxito" ||
            response?.data?.mensajeSistema === "Evento registrado para envio posterior."
          ) {
            msmSwalExito(response?.data?.mensajeSistema);
            setOpenLoader(false);
          } else {
            msmSwalError(
              response.data.mensajeSistema != null
                ? response.data.mensajeSistema
                : "Error al anular el comprobante."
            );
            setOpenLoader(false);
          }
        })
        .catch((exception) => {
          if (exception.response) {
            msmSwalError(
              exception.response.data.apierror
                ? exception.response.data.apierror.mensaje
                  ? exception.response.data.apierror.mensaje
                  : "Error al anular el comprobante."
                : "Error al anular el comprobante."
            );
            setOpenLoader(false);
          } else {
            msmSwalError(
              "Existen problemas en la red. Contáctese con el administrador del Sistema."
            );
          }
          setOpenLoader(false);
        });
    }
  };

  const searchBill = async () => {
    const newErrors = validateCufe();
    setErrors(newErrors);
    let isValid = Object.entries(newErrors).length > 0;
    if (!isValid) {
      await httpRepo
        .get(API_GET_VOUCHER_BY_CUFE_2 + eventAnnulation.cufe)
        .then((response) => {
          if (response.status === 200) {
            if (response.data != null && response.data != "") {
              setVoucher(response.data);
              setTipoComprobanteElectronico(
                response.data.tipoComprobanteElectronico
              );
              setIsDisabled(false);
            } else {
              enqueueSnackbar(
                `No existen un comprobante con el cufe ingresado`,
                {
                  variant: "info",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                }
              );
            }
          }
        })
        .catch(() => {
          enqueueSnackbar(
            `Existen problemas para consultar el CUFE contactese con el administrador`,
            {
              variant: "info",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            }
          );
        });
    }
  };

  return (
    <Fragment className={classes.fragment}>
      <Card className={classes.cardContent}>
        <Grid container xs={12} justify="center" alignItems="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Evento de anulación"}
            avatar={<AssessmentIcon></AssessmentIcon>}
          />
        </Grid>

        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          align="center"
        >
          <Grid container>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
            <Grid item xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Los campos marcados con (
                <font color={palette.error.main}> *</font>) son obligatorios:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                CUFE de la FE a ser anulada:
                <font color={palette.error.main}> *</font>
              </Typography>
            </Grid>
            <Grid item lg={7} xs={12}>
              <input
                className={styleInput(errors.cufe, eventAnnulation.cufe)}
                type="text"
                name="cufe"
                value={eventAnnulation.cufe}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.cufe ? (
                <p className={classesApp.errorLetters}>{errors.cufe}</p>
              ) : null}
            </Grid>
            <Grid item xs={12} md={2} className={classes.divForm}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: 15 }}
                align="center"
                startIcon={<PageviewIcon />}
                onClick={() => searchBill()}
              >
                {" "}
                Buscar
              </Button>
            </Grid>
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Monto Total del comprobante:
              </Typography>
            </Grid>
            <Grid item lg={3} xs={12}>
              <input
                className={styleInput(errors.motivo)}
                type="text"
                name="monto"
                value={voucher.valorTotal}
                disabled={true}
                autoComplete="off"
              />
            </Grid>
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Tipo de comprobante:
              </Typography>
            </Grid>
            <Grid item lg={4} xs={12}>
              <input
                className={styleInput(errors.motivo)}
                type="text"
                name="monto"
                value={tipoComprobanteElectronico.nombreComprobante}
                disabled={true}
                autoComplete="off"
              />
            </Grid>
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Motivo de la anulación:
                <font color={palette.error.main}> *</font>
              </Typography>
            </Grid>
            <Grid item lg={9} xs={12}>
              <input
                className={styleInput(errors.motivo, eventAnnulation.motivo)}
                type="text"
                name="motivo"
                value={eventAnnulation.motivo}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.motivo ? (
                <p className={classesApp.errorLetters}>{errors.motivo}</p>
              ) : null}
            </Grid>
          </Grid>
          <br></br>
          <Grid>
            <Divider className={classes.divider} />
          </Grid>

          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} lg={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={annulation}
                disabled={isDisabled}
              >
                <CancelIcon /> Anular
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Backdrop className={classes.backdrop} open={openLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Card>
    </Fragment>
  );
};

export default EventAnnulation;
